














































import { defineComponent } from "@vue/composition-api"
import {
  useFindOneBooking,
  useStartBooking,
  useReserveBooking,
} from "@/app/reactive/booking"
import Address from "@/app/components/facility/Address.vue"
import Subtitle from "@/app/components/common/Subtitle.vue"
import Content from "@/app/components/common/Content.vue"
import Hint from "@/app/components/common/Hint.vue"
import Prices from "@/app/components/facility/Prices.vue"
import { FacilityModel } from "@/app/models/facility.model"

export default defineComponent({
  name: "FacilityControls",
  components: {
    Address,
    Subtitle,
    Content,
    Hint,
    Prices,
  },
  props: {
    facility: {
      type: Object as () => FacilityModel,
      required: true,
    },
  },
  setup() {
    const { startBooking } = useStartBooking()
    const { reserveBooking } = useReserveBooking()
    const { booking } = useFindOneBooking()

    async function start() {
      await startBooking(booking)
    }

    async function reserve() {
      await reserveBooking(booking)
    }

    return {
      booking,
      start,
      reserve,
      stop,
    }
  },
})
